const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快',
    desc: '7×24小时实时追踪，覆盖全网50+信源，爆料不隔夜，第一时间将最新资讯推送至吃瓜群众手中。',
    color: 'bg-primary-500',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度追踪',
    desc: '独家内幕深度挖掘，不止于表面。从蛛丝马迹中还原真相，为吃瓜群众呈现事件完整面貌。',
    color: 'bg-accent-500',
  },
  {
    icon: 'ri-group-line',
    title: '群众视角',
    desc: '百万吃瓜群众在线互动，全民参与爆料讨论。你的每一个观点，都可能成为新的吃瓜方向。',
    color: 'bg-secondary-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全直达',
    desc: '专属入口稳定直达，多重防护保障访问体验。无论何时何地，畅享无忧吃瓜体验。',
    color: 'bg-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-8 md:mb-10">
          吃瓜优势
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div key={idx} className="text-center p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg">
              <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-lg ${item.color} text-background-50 mb-4`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}